"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DriveItemType;
(function (DriveItemType) {
    DriveItemType["Folder"] = "FOLDER";
    DriveItemType["File"] = "FILE";
})(DriveItemType = exports.DriveItemType || (exports.DriveItemType = {}));
//# sourceMappingURL=Drive.js.map